module.exports = __webpack_public_path__ + "static/media/orinocco37.f542faeb.jpg";